export const baseUrlGenerator = () => {
	const extractedUrl =
		window.location.href.indexOf(".com") > -1
			? `${window.location.href.split(".com")[0]}.com`
			: window.location.href;

	const finalBaseUrl =
		process.env.PREACT_APP_ENV_NAME === "local"
			? process.env.PREACT_APP_PARTNER_NAVIGATION_ENDPOINT.slice(0, -1)
			: extractedUrl;

	return finalBaseUrl;
};
